import React from "react"
import {StyledSelect, StyledOutlinedInput} from "./component"
import {SelectProps} from "../.."

export const ClubCountrySelect = ({
    value,
    onChange,
    onOpen,
    onKeyPress,
    MenuProps,
    input,
    IconComponent,
    children,
}: SelectProps) => {
    return (
        <StyledSelect
            value={value}
            onChange={onChange}
            onOpen={onOpen}
            onKeyPress={onKeyPress}
            MenuProps={MenuProps}
            IconComponent={IconComponent}
            input={
                <StyledOutlinedInput
                    data-testid="country-language-selector-select-input"
                    name="country-language-selector-select"
                    id="country-language-selector-select"
                />
            }
        >
            {children}
        </StyledSelect>
    )
}

export default ClubCountrySelect
